import React from "react";

/* The mockups' own icon set, traced path for path out of _mockups/v3. They are plain <svg>
   so `.nav a svg`, `.btn svg` and `.lk svg` in the design system size them — no classes. */

const S = ({ children, w = 1.8 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={w} aria-hidden="true">{children}</svg>
);

export const Mark = () => (
  <S w={2}>
    <path d="M4 7h7M4 12h12M4 17h7" strokeLinecap="round" />
    <circle cx="18" cy="7" r="2.2" fill="#0055FF" stroke="none" />
    <circle cx="18" cy="17" r="2.2" fill="#0055FF" stroke="none" />
  </S>
);

export const I = {
  idea: () => <S><path d="M9 18h6M10 21h4" /><path d="M12 3a6 6 0 0 0-3.6 10.8c.7.5 1.1 1.3 1.1 2.1V16h5v-.1c0-.8.4-1.6 1.1-2.1A6 6 0 0 0 12 3z" /></S>,
  grid: () => (
    <S><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></S>
  ),
  plus: () => <S w={2}><path d="M12 5v14M5 12h14" /></S>,
  doc: () => <S><path d="M14 3v5h5" /><path d="M19 8v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7z" /></S>,
  coins: () => <S><path d="M15.5 6A3.5 3.5 0 0 0 9 8v9" /><path d="M7 13h6" /><path d="M7 17h10" /></S>,
  card: () => <S><rect x="3" y="6" width="18" height="13" rx="2.5" /><path d="M16 12.5h2" /></S>,
  bars: () => <S><path d="M4 20V10M10 20V4M16 20v-7M22 20H2" /></S>,
  mail: () => <S><rect x="3" y="5" width="18" height="14" rx="2.5" /><path d="M4 7.5l8 6 8-6" /></S>,
  kit: () => <S><rect x="3" y="4" width="18" height="14" rx="2.5" /><path d="M8 21h8" /><path d="M7 9h6M7 13h4" /></S>,
  cog: () => (
    <S><circle cx="12" cy="12" r="3.2" />
      <path d="M12 3v2.4M12 18.6V21M3 12h2.4M18.6 12H21M5.6 5.6l1.7 1.7M16.7 16.7l1.7 1.7M18.4 5.6l-1.7 1.7M7.3 16.7l-1.7 1.7" /></S>
  ),
  people: () => <S><circle cx="9" cy="8" r="3" /><path d="M3 20a6 6 0 0 1 12 0" /><path d="M16 11h5M18.5 8.5v5" /></S>,
  layers: () => <S><path d="M3 7l9-4 9 4-9 4-9-4z" /><path d="M3 12l9 4 9-4" /><path d="M3 17l9 4 9-4" /></S>,
  clock: () => <S><path d="M12 7v5l3 2" /><circle cx="12" cy="12" r="9" /></S>,
  bell: () => <S><path d="M18 9a6 6 0 1 0-12 0c0 6-2 7-2 7h16s-2-1-2-7" /><path d="M10.3 20a2 2 0 0 0 3.4 0" /></S>,
  case: () => <S><rect x="3" y="7" width="18" height="12" rx="2" /><path d="M8 7V5h8v2" /></S>,
  code: () => <S><path d="M7 8l-4 4 4 4M17 8l4 4-4 4M14 4l-4 16" /></S>,
  list: () => <S><path d="M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01" /></S>,
  pipeline: () => <S><path d="M6 3v12a3 3 0 0 0 3 3h9" /><circle cx="6" cy="18" r="2.5" /><circle cx="18" cy="6" r="2.5" /></S>,
  approve: () => <S><path d="M9 11l3 3 5-5" /><rect x="3" y="4" width="18" height="16" rx="2.5" /></S>,
  user: () => <S><circle cx="12" cy="8" r="3.2" /><path d="M5 20a7 7 0 0 1 14 0" /></S>,
  inbox: () => <S><path d="M3 7l9 6 9-6" /><rect x="3" y="5" width="18" height="14" rx="2.5" /></S>,
  bolt: () => <S><path d="M13 2 4.5 13H11l-1 9 9-12h-6.5z" /></S>,
  star: () => <S><path d="M12 3l1.8 4.6L18.5 9l-3.5 3 1 4.8-4-2.4-4 2.4 1-4.8L5.5 9l4.7-1.4z" /></S>,
  bin: () => <S><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" /></S>,
  arrow: () => <S w={1.9}><path d="M5 12h14M13 6l6 6-6 6" /></S>,
  back: () => <S w={1.9}><path d="M19 12H5M11 18l-6-6 6-6" /></S>,
  chevron: () => <S w={2}><path d="m6 9 6 6 6-6" /></S>,
  search: () => <S w={1.9}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.6-3.6" /></S>,
  burger: () => <S w={2}><path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" /></S>,
  close: () => <S w={2}><path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" /></S>,
  logout: () => <S><path d="M15 17l5-5-5-5" /><path d="M20 12H9" /><path d="M13 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7" /></S>,
  download: () => <S><path d="M12 4v11" /><path d="M7.5 11 12 15.5 16.5 11" /><path d="M4 20h16" /></S>,
  plug: () => <S><path d="M9 3v6M15 3v6" /><path d="M6 9h12v3a6 6 0 0 1-12 0z" /><path d="M12 18v3" /></S>,
  link: () => <S><path d="M10.5 13.5a4 4 0 0 0 5.7 0l2.3-2.3a4 4 0 0 0-5.7-5.7l-1 1" /><path d="M13.5 10.5a4 4 0 0 0-5.7 0l-2.3 2.3a4 4 0 0 0 5.7 5.7l1-1" /></S>,
  shield: () => <S><path d="M12 3l8 3v6c0 5-3.4 8.2-8 9.5C7.4 20.2 4 17 4 12V6z" /><path d="M9 12l2.2 2.2L15.5 10" /></S>,
  sparkle: () => <S><path d="M12 3v4M12 17v4M3 12h4M17 12h4" strokeLinecap="round" /><circle cx="12" cy="12" r="3.2" /></S>,
};

export default I;
